import { LIST_OTHER_USER_DATA } from '../actions/users'

const initialState = {
	otherUser: {
		username: '',
		texts: [],
		edits: []
	}
}

export default function reducer(state=initialState, action) {
	if (action.type === LIST_OTHER_USER_DATA) {
		return Object.assign({}, state, { otherUser: action.userObj })
	}
	return state
}


// WEBPACK FOOTER //
// ./src/reducers/users.js